import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IButtonPayloadModel } from 'STORE/Messages/Message/Payload/ButtonsPayload/ButtonsPayload';
import { OpenUrlButtonPayload } from 'STORE/Messages/Message/Payload/ButtonsPayload/OpenUrlButtonPayload';

import { CommandButton } from '../CommandButton/CommandButton';
import { useOpenUrlCommandButtonPresenter } from './OpenUrlCommandButton.presenter';

interface IOpenUrlCommandButtonProps {
  groupId: string;
  button: IButtonPayloadModel;
}

export const OpenUrlCommandButton: FC<IOpenUrlCommandButtonProps> = observer((props) => {
  const { button } = props;

  const presenter = useOpenUrlCommandButtonPresenter(button.payload as OpenUrlButtonPayload);

  return (
    <CommandButton
      onClick={presenter.onClick}
      title={button.title}
    />
  );
});
